<template>
  <ComponentPreviewModal
    :open="showComponentPreviewModal"
    :close="handleCloseComponentPreviewModal"
    :shortCode="`[${getComponentName(data.id)} name=${data.id}|demo]`"
  />
  <tr class="border-b-2 border-gray-50">
    <td
      class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
    >
      {{ data.id }}
    </td>
    <td
      class="cursor-pointer border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
    >
      <SimpleTooltip :content="tooltipContent">{{
        data.display_name
      }}</SimpleTooltip>
    </td>
    <td
      class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
    >
      {{ data.description }}
    </td>

    <td
      class="flex items-center justify-center border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right"
    >
      <button
        @click="handleOpenComponentPreviewModal"
        class="bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        demo
      </button>

      <button
        @click="handleRedirect(data)"
        class="bg-amber-500 text-white active:bg-amber-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        Edit
      </button>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import ABILogo from "@/assets/imgs/logo.png";
import settings from "@/common/config";
import ComponentPreviewModal from "@/components/Shared/Modal/ComponentPreviewModal";
import SimpleTooltip from "@/components/Shared/Tooltip/SimpleTooltip";

export default {
  components: { ComponentPreviewModal, SimpleTooltip },
  data() {
    return {
      ABILogo,
      showComponentPreviewModal: false,
      iframeUrl: "www.google.com"
    };
  },
  props: {
    data: {
      type: [Array, Object],
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  computed: {
    domain() {
      return this.getRegion === "au"
        ? settings.AU_API_URL
        : this.getRegion === "nz"
        ? settings.NZ_API_URL
        : settings.UK_API_URL;
    },
    tooltipContent() {
      return `<div style='overflow:hidden;height:160px'><iframe content='no-cache' style='transform: scale(0.2,0.2); width:500%;height:800px; transform-origin:0 0;' src='${
        this.domain
      }/preview-instance/?instance_shortcode=[${this.getComponentName(
        this.data.id
      )} name=${
        this.data.id
      }|demo]&key=RrrgMXM57xRPsMHuj52WBqewF0vMCgBL&time=${new Date().getTime()}' frameborder='0'></iframe></div>`;
    },
    statusColor() {
      switch (this.applicant.status) {
        case "Approved":
          return "text-green-500";
        case "Pending":
          return "text-yellow-500";
        case "Rejected":
          return "text-red-500";
        default:
          return "text-gray-100";
      }
    },
    ...mapGetters(["sideBarComponents", "getAllComponent", "getRegion"])
  },
  methods: {
    handleRedirect(data) {
      this.$router.push({
        path: `/component/${data.id}`
      });
    },
    getComponentName(componentId) {
      if (this.getAllComponent.find((item) => item.id === componentId)) {
        return this.getAllComponent.find((item) => item.id === componentId)
          .name;
      } else {
        return null;
      }
    },
    handleOpenComponentPreviewModal() {
      this.showComponentPreviewModal = true;
    },
    handleCloseComponentPreviewModal() {
      this.showComponentPreviewModal = false;
    }
  }
};
</script>
